import { CustomizedRoute } from '../CustimizedRoute/CustomizedRoute';
import { useMultiLayerDrawerContext } from '../MultiLayerDrawerProvider/MultiLayerDrawerProvider';

export const ModuleRoute = props => {
    const { registerModulePage, modulePages } = useMultiLayerDrawerContext();

    return <CustomizedRoute {...props} registerPage={registerModulePage} pages={modulePages} />;
};
